/**
 * Stats Grid Component
 * 4-column grid showing user statistics
 */

import { Scan, Flame, Users, Gift } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import type { ProfileStats } from '../types';
import { STAT_ICON_COLORS } from '../utils/constants';

interface StatsGridProps {
  stats: ProfileStats;
}

export function StatsGrid({ stats }: StatsGridProps) {
  const { t } = useLanguage();

  const statItems = [
    {
      value: stats.totalAsIsScans,
      label: t('profile.stats.asIsScans', 'As-Is Scans'),
      icon: Scan,
      colors: STAT_ICON_COLORS.scans,
    },
    {
      value: stats.streakDays,
      label: t('profile.stats.dayStreak', 'Day Streak'),
      icon: Flame,
      colors: STAT_ICON_COLORS.streak,
    },
    {
      value: stats.referralCount,
      label: t('profile.stats.referrals', 'Referrals'),
      icon: Users,
      colors: STAT_ICON_COLORS.referrals,
    },
    {
      value: `+${stats.bonusWatchlistSlots}`,
      label: t('profile.stats.bonusSlots', 'Bonus Slots'),
      icon: Gift,
      colors: STAT_ICON_COLORS.slots,
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statItems.map((item) => (
        <div
          key={item.label}
          className="bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg hover:border-primary-200 transition-all duration-200"
        >
          <div className="flex items-center gap-3">
            <div className={`p-2 ${item.colors.bg} rounded-lg`}>
              <item.icon className={`w-5 h-5 ${item.colors.icon}`} />
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">{item.value}</div>
              <div className="text-sm text-gray-500">{item.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
